var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirect-view"},[(_vm.showLoader)?_c('dn-loader',{staticClass:"with-margins"}):_c('div',[_c('div',{staticClass:"no-rights"},[_vm._v("Nie udało się się przekierować. Spróbuj ponownie.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }